export default __webpack_public_path__ + "static/media/Big-time-gaming.cdbabc6d.png";